import {
  SlideGroupName,
  usePitchDeckTemplateActivityQuery
} from 'generated/graphql';
import _ from 'lodash';
import {
  pitchDeckUtil,
  useLoading
} from 'modules';




function isValidGroupName(group?: string): group is SlideGroupName {
  return !!group && ['byPitchExample', 'bySlideType', 'otherResources'].includes(group);
}

export function usePitchDeckThumbnailActivity(group?: string, title?: string) {
  const groupName = isValidGroupName(group) ? group : 'bySlideType';

  const tuple = usePitchDeckTemplateActivityQuery({
    variables: {
      includeSlide: !!title,
      input: {
        group: groupName,
        title
      }
    },
    fetchPolicy: 'cache-first'
  });

  const loading = useLoading([tuple]);

  const filteredData = title
    ? tuple.data?.slides
    : tuple.data?.slides.filter(slide => pitchDeckUtil.displayingThumbnails[groupName].includes(slide.thumbnail.fileName));



  return {
    loading,
    data: _.sortBy( _.map(filteredData, data => ({
      id: data.id,
      slideGroup: {
        name: data.slideGroup.name,
        displayName: data.slideGroup.displayName
      },
      thumbnailKey: data.thumbnail?.id ?? '',
      slide: data.slide ? {
        id: data.slide.id,
        key: data.slide.key,
        fileName: data.slide.fileName
      } : undefined,
      title: data.title
    })), item => pitchDeckUtil.getRankingFromSlides(item)),
    pageInfo: getPageInfo(groupName, title)
  };
}



function getPageHeading(group: SlideGroupName) {
  if (group === 'bySlideType') {
    return 'By Slide Types';
  } else if (group === 'byPitchExample') {
    return 'By Pitch Example';
  } else if (group === 'otherResources') {
    return 'Other Resources';
  }
  return '';
}

function getBackButtonText(group: SlideGroupName) {
  if (group === 'bySlideType') {
    return 'Back to Slide Types';
  } else if (group === 'byPitchExample') {
    return 'Back to Pitch Example';
  } else if (group === 'otherResources') {
    return 'Back to Other Resources';
  }
  return 'Back to Pitch Decks';
}

function getPageInfo(group: SlideGroupName, title?: string) {
  if (!title) {
    return {
      heading: getPageHeading(group),
      backButtonText: 'Back to Pitch Decks'
    };
  }

  return {
    heading: title,
    backButtonText: getBackButtonText(group)
  };
}
